import React from "react";

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-10 px-6">
      <div className="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-lg">
        <h1 className="text-3xl font-bold mb-6">Terms of Service</h1>
        <p className="text-sm text-gray-500 mb-6">Effective Date: September 1st, 2025</p>

        <p className="mb-4">
          Welcome to PoemXtra! By accessing or using our website, you agree to these Terms of Service. Please read them carefully.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">1. Acceptance of Terms</h2>
        <p className="mb-4">By using PoemXtra, you agree to comply with these Terms and all applicable laws.</p>

        <h2 className="text-xl font-semibold mt-6 mb-2">2. Eligibility</h2>
        <p className="mb-4">You must be at least 5 years old to use PoemXtra.</p>

        <h2 className="text-xl font-semibold mt-6 mb-2">3. User Accounts</h2>
        <ul className="list-disc pl-6 mb-4">
          <li>You may need to create an account for some features.</li>
          <li>You are responsible for keeping your credentials safe.</li>
          <li>You must provide accurate and up-to-date info.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-6 mb-2">4. Content Submission</h2>
        <p className="mb-4">
          Users may submit poems or content. By submitting, you grant PoemXtra a license to display and promote your content, while retaining ownership.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">5. Intellectual Property</h2>
        <p className="mb-4">Site content and branding are property of PoemXtra and protected by copyright/trademark laws.</p>

        <h2 className="text-xl font-semibold mt-6 mb-2">6. Prohibited Activities</h2>
        <ul className="list-disc pl-6 mb-4">
          <li>Unlawful use.</li>
          <li>Posting spam or harmful code.</li>
          <li>Harassment or abuse of others.</li>
          <li>Hacking or disrupting the website.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-6 mb-2">7. Termination</h2>
        <p className="mb-4">We may suspend or terminate accounts that violate these Terms.</p>

        <h2 className="text-xl font-semibold mt-6 mb-2">8. Disclaimer of Warranties</h2>
        <p className="mb-4">PoemXtra is provided “as is” and “as available.” No guarantees of uptime or error-free service.</p>

        <h2 className="text-xl font-semibold mt-6 mb-2">9. Limitation of Liability</h2>
        <p className="mb-4">
          PoemXtra shall not be liable for any damages from use of the site, including loss of data, profits, or content.
        </p>

        <h2 className="text-xl font-semibold mt-6 mb-2">10. Changes to Terms</h2>
        <p className="mb-4">We may update these Terms from time to time. Continued use means acceptance of changes.</p>
      </div>
    </div>
  );
};

export default TermsOfService;
